import React from 'react'

const RULER_THICKNESS = 32
const RULER_END_BUFFER = 28
const BASE_PPI = 72
const MIN_LABEL_SPACING_PX = 28

function labelIntervalForZoom(zoom) {
  const minimumInterval = Math.ceil(MIN_LABEL_SPACING_PX / (BASE_PPI * zoom))
  return [1, 2, 5, 10, 20, 50, 100].find(interval => interval >= minimumInterval) || 100
}

export default function SheetRuler({ direction, lengthPx, zoom }) {
  const isHorizontal = direction === 'horizontal'
  const scaledLength = lengthPx * zoom
  const rulerLength = scaledLength + RULER_END_BUFFER

  // Total inches to display based on unscaled length
  const totalInches = Math.floor(lengthPx / BASE_PPI)
  const labelInterval = labelIntervalForZoom(zoom)

  const ticks = []
  for (let i = 0; i <= totalInches; i++) {
    const pos = i * BASE_PPI * zoom
    const isMajor = i % labelInterval === 0

    if (isHorizontal) {
      ticks.push(
        <g key={i}>
          <line
            x1={pos}
            y1={RULER_THICKNESS}
            x2={pos}
            y2={RULER_THICKNESS - (isMajor ? 10 : 5)}
            strokeWidth={1}
          />
          {isMajor && i > 0 && (
            <text
              x={pos + 2}
              y={RULER_THICKNESS - 12}
              fontSize={9}
              fontFamily="system-ui, sans-serif"
            >
              {i}"
            </text>
          )}
        </g>
      )
    } else {
      ticks.push(
        <g key={i}>
          <line
            x1={RULER_THICKNESS}
            y1={pos}
            x2={RULER_THICKNESS - (isMajor ? 10 : 5)}
            y2={pos}
            strokeWidth={1}
          />
          {isMajor && i > 0 && (
            <text
              x={2}
              y={pos + 10}
              fontSize={9}
              fontFamily="system-ui, sans-serif"
              writingMode="vertical-rl"
              transform={`rotate(-90, 10, ${pos + 4})`}
            >
              {i}"
            </text>
          )}
        </g>
      )
    }
  }

  if (isHorizontal) {
    return (
      <div
        className="sheet-ruler sheet-ruler--horizontal"
        style={{ width: rulerLength, height: RULER_THICKNESS }}
      >
        <svg width={rulerLength} height={RULER_THICKNESS}>
          <rect width={rulerLength} height={RULER_THICKNESS} />
          {ticks}
        </svg>
      </div>
    )
  }

  return (
    <div
      className="sheet-ruler sheet-ruler--vertical"
      style={{ width: RULER_THICKNESS, height: rulerLength }}
    >
      <svg width={RULER_THICKNESS} height={rulerLength}>
        <rect width={RULER_THICKNESS} height={rulerLength} />
        {ticks}
      </svg>
    </div>
  )
}
